import './TradingTokenPage.scss';
import { useTranslation } from 'react-i18next';
import { assets } from '../../../assets/assets';
import { app, useAppUpdates } from '../../../data/Controllers/AppController';
import { TradingTokenTabs } from './TradingTokenTabs/TradingTokenTabs';
import { TradingTokenFooter } from './TradingTokenFooter/TradingTokenFooter';
import { useEffect, useState } from 'react';
import { UIEvents } from '../../../data/Controllers/UIController/UITypes';
import { Page } from '../Page';
import { getMyOffchainTokenPointAmount } from '../../../replicant/features/tradingMeme/tradingMeme.getters';
import { shareDeeplink } from '../../../data/sharing';
import { resolveProfilePicture } from '../../../replicant/features/game/game.getters';
import { MemesEvents } from '../../../data/Controllers/Memes/MemesController';
import { HP } from '../../../replicant/lib/HighPrecision';

export const TradingTokenPage = () => {
  const { t } = useTranslation();
  const { visible } = app.views.TradingTokenPage;
  const { memes } = app;

  useAppUpdates({
    id: 'TradingTokenPage',
    listener: app.views.TradingTokenPage.attachEventListener(),
  });
  useAppUpdates({
    id: 'TradingTokenPage/UIEvents.OnBalanceUpdate',
    listener: app.ui.attachEventListener(UIEvents.OnBalanceUpdate),
  });
  useAppUpdates({
    id: 'TradingTokenPage/MemesEvents.OnCurrentTokenUpdate',
    listener: app.memes.attachEventListener(MemesEvents.OnCurrentTokenUpdate),
  });

  const [tabUpdateCounter, setTabUpdateCounter] = useState(0);

  useEffect(() => {
    if (visible) {
      // If for some reason there's no data set, close itself
      if (!memes.currentMeme.meme) {
        app.ui.drawer.close();
        return;
      }

      app.track('memeoffchainToken_detail_view', {
        memeoffchainToken_name: memes.currentMeme.meme.name,
        memeoffchainTokenID: memes.currentMeme.meme.id,
        current_point_price: memes.currentMeme.meme.pointPrice,
        current_token_price: memes.currentMeme.meme.tokenPrice,
        current_owned: memes.currentMeme.meme.creatorId === app.state.id,
        total_holders: memes.currentMeme.meme.holderCount,
        source: memes.market.filter,
      });
    }
  }, [visible, memes.currentMeme.meme?.id]);

  const goToProfile = () => {
    console.warn('>>> trading.currentMeme.token');
    if (!memes.currentMeme.meme) return;
    app.nav.goToProfile(memes.currentMeme.meme.creatorId);
  };

  const onShare = () => {
    shareDeeplink('TradingTokenPage', {
      messageOpts: {
        title: memes.currentMeme.meme?.name as unknown as string,
        text: memes.currentMeme.meme?.description
          .description as unknown as string,
      },
      deeplinkOpts: app.nav.getDeeplinkOpts('TradingTokenPage'),
    });
  };

  const onEditInfo = () => {
    app.nav.goTo('TradingEditLinksPage');
  };

  if (!memes.currentMeme.meme) {
    return null;
  }

  const owned = getMyOffchainTokenPointAmount(
    app.state,
    memes.currentMeme.meme.id,
  );

  const onTabChange = () => {
    setTabUpdateCounter(tabUpdateCounter + 1);
  };

  const tickerName = memes.currentMeme.meme?.ticker ?? '#';

  return (
    <Page id="trading-token" visible={visible}>
      <div className="trading-token-layout trading-details">
        <div className="trading-token-header">
          {/* <div className="trading-token-header-bg" /> */}

          {/* offchainToken image */}

          <div className="trading-token-header-image">
            <img src={memes.currentMeme.meme.image} />
          </div>

          <div className="trading-token-header-info">
            <div className="trading-token-header-title">
              {memes.currentMeme.meme.name}
            </div>

            {/* author */}
            <div className="trading-token-author" onClick={goToProfile}>
              <div className="trading-token-author-by">{tickerName}</div>
              <div className="trading-token-author-by">{'•'}</div>
              <div className="trading-token-author-by">{t('tiktok_by')}</div>
              <div className="trading-token-author-image">
                <img
                  src={resolveProfilePicture(
                    memes.currentMeme.meme.creatorId,
                    memes.currentMeme.meme.creatorImage,
                  )}
                />
              </div>
              <div className="trading-token-author-name">
                {memes.currentMeme.meme.creatorName}
              </div>
            </div>

            {/* buttons */}
            <div className="trading-token-buttons">
              {memes.currentMeme.isOwner && (
                <div className="trading-token-button-edit" onClick={onEditInfo}>
                  {t('trading_edit_info_cta')}
                </div>
              )}

              <div className="trading-token-button-owned">
                {t('trading_token_x_owned', {
                  amount: HP(owned).toFixed(4),
                })}{' '}
              </div>
              <div className="trading-token-button-share" onClick={onShare}>
                <img src={assets.share_white} />
              </div>
            </div>
          </div>
        </div>

        {/* tabs */}
        <TradingTokenTabs onTabChange={onTabChange} />

        {/* footer - todo carles: season2 */}
        {/* <TradingTokenFooter footerMode={'normal'} collapse={tabUpdateCounter} /> */}
        <TradingTokenFooter footerMode={'normal'} />
      </div>
    </Page>
  );
};
